/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import clsx from 'clsx';
import {
    Box,
    Grid,
    Paper,
    TextField,
    Button,
    Typography,
    Avatar,
    IconButton, InputAdornment
} from '@mui/material';
import { Link } from "react-router-dom";
import customStyles from "../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../redux/actions";
import logoImg from "../../../../assets/images/logo.png";
import loginImg from "../../../../assets/images/login.png"
import { Image } from "antd";
import { emptyValidation } from "../../../../helpers/validation";
import { toast } from 'react-toastify';
import usePrevious from "../../../Shared/components/Previous";
import { checkLogin, idNamingConversion } from '../../../../helpers/utilities';
import { isDesktop } from '../../../../setup/desktopApi';
//import { Context } from "../../../Shared/components/Wrapper";

import Visibility from "../../../Shared/components/Icons/Visibility";
import VisibilityOff from "../../../Shared/components/Icons/VisibilityOff";
import { NormalSelect } from "../../../Shared/components/CustomSelect";

const Login = (props) => {
    const { loggedInUser, loginError, loginLoader, event } = useSelector(state => state.authReducer);
    const [email, setEmailAddress] = useState('');
    const [password, setPassword] = useState('');
    const [errorEmailMessage, setErrorEmailMessage] = useState(false);
    const [errorPasswordMessage, setErrorPasswordMessage] = useState(false);
    const dispatch = useDispatch();
    const { history } = props;
    const prevLoggedInUser = usePrevious(loggedInUser);
    const prevloginError = usePrevious(loginError);
    const [passwordShown, setPasswordShown] = useState(false);
    //const context = useContext(Context);

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyEmail = emptyValidation('Mobile Number or Email', email);
        let emptyPassword = emptyValidation('Password', password);
        setErrorEmailMessage(false);
        setErrorPasswordMessage(false);
        if (emptyEmail.isValid && emptyPassword.isValid) {
            // Desktop + no connection → verify against the encrypted vault offline;
            // otherwise the normal online login. Web always uses online.
            const offline = isDesktop() && typeof navigator !== 'undefined' && !navigator.onLine;
            dispatch({
                type: offline ? actions.OFFLINE_LOGIN_START : actions.LOGIN_START,
                loginData: { email: email, password: password },
            });
        } else {
            if (emptyEmail.errors !== '') {
                setErrorEmailMessage(emptyEmail.errors);
            } if (emptyPassword.errors !== '') {
                setErrorPasswordMessage(emptyPassword.errors);
            }
        }
    }


    useEffect(() => {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let foo = params.get('status');
        if (foo === 'expired') {
            toast('Please login and continue');
        }
        checkLogin(props);
        emptyState();
        emptyStateInput();
    }, []);

    const emptyState = () => {
        setErrorEmailMessage(false);
        setErrorPasswordMessage(false);
    }

    const emptyStateInput = () => {
        setEmailAddress('');
        setPassword('');
    }

    useEffect(() => {
        if (prevLoggedInUser !== undefined && loggedInUser && prevLoggedInUser !== loggedInUser) {
            toast.dismiss();
            if (event === 'CHANGE PASSWORD') {
                toast('Please change your password');
            } else {
                toast('You have Logged In successfully');
            }
            // Vault seeding now happens in the login saga (it has the full session).
            history.replace('/');
        } else if (prevloginError !== undefined && loginError && prevloginError !== loginError) {
            if (loginError?.error?.code === 'VALIDATION_FAILED') {
                setErrorEmailMessage('Enter valid user name');
            } else {
                const raw = loginError?.error?.message;
                const parts = typeof raw === 'string' ? raw.split("|") : [];
                if (parts[0] === 'email') {
                    setErrorEmailMessage(parts[1]);
                } else if (parts[0] === 'password') {
                    setErrorPasswordMessage(parts[1]);
                } else if (raw) {
                    // Offline-login / general errors aren't field-scoped — surface them.
                    toast.error(raw);
                }
            }
        }
    }, [loggedInUser, loginError]);

    const classes = customStyles();
    return (
        <div className={clsx(classes.backgroundWhite, classes.boxBorder1)}>
            <Paper className={clsx(classes.authContainer)} sx={{ p: 2 }}>
                <Grid container className={clsx(classes.authRoot, classes.fullHei)}>
                    <Link to="/login" className={clsx(classes.customLogoLink)}>
                        <Avatar
                            alt="Logo"
                            src={logoImg}
                            className={clsx(classes.customLogo)}
                            variant={'square'}
                        />
                    </Link>
                    <Grid xxl={7} xl={7} lg={7} md={7} sm={5} item className={classes.mobileDisplay}>
                        <Image
                            alt="Login"
                            preview={false}
                            src={loginImg}
                            variant={'square'}
                        />
                    </Grid>
                    <Grid xxl={5} xl={5} lg={5} md={5} sm={7} xs={12} className={clsx(classes.cardSize, classes.loginForm)} item>
                        <Paper style={{ backgroundColor: 'transparent' }}>
                            <Grid align='center'>
                                <Typography variant="h6" className={clsx(classes.customTitle, classes.primaryFont, classes.bold)}>
                                    Login</Typography>
                            </Grid>
                            <Box
                                className={clsx(classes.removeUnderline)}
                                component="form"
                                autoComplete="off"
                                onSubmit={(e) => handleSubmit(e)}>
                                <TextField
                                    label={"Mobile Number or Email"}
                                    autoComplete="email"
                                    value={email}
                                    fullWidth
                                    error={errorEmailMessage && true}
                                    helperText={errorEmailMessage}
                                    variant={'standard'}
                                    id={idNamingConversion('Mobile Number or Email', 'login', 'TextField')}
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setEmailAddress(e.target.value)}
                                />
                                <TextField
                                    label={"Password"}
                                    autoComplete="current-password"
                                    type={passwordShown ? "text" : "password"}
                                    fullWidth
                                    variant={'standard'}
                                    id={idNamingConversion('Password', 'login', 'TextField')}
                                    error={errorPasswordMessage && true}
                                    helperText={errorPasswordMessage}
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        },
                                        endAdornment: (
                                            <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordShown(!passwordShown)} position="end" >
                                                <IconButton>
                                                    {passwordShown ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <Button
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    fullWidth
                                    id={idNamingConversion('Login', 'login', 'Button')}
                                    className={clsx(classes.margin40t, classes.modalBtn, classes.bold, { [classes.loading]: loginLoader })}
                                >Login</Button>
                                <div className={classes.loading}></div>
                            </Box>
                            <Typography className={clsx(classes.margin50t, classes.forgotPassword)}>
                                <Link to={'/forgot-password'} id={idNamingConversion('Forgot password', 'login', 'Link')} className={clsx(classes.textDecoration, classes.color, classes.fonSize13, classes.bold)}>
                                    Forgot password?
                                </Link>
                                <span className={clsx(classes.fonSize13, classes.mobileDisplay)}>
                                    Don't have an account?  <Link to={'/register'} id={idNamingConversion('Register', 'login', 'Link')} className={clsx(classes.textDecoration, classes.registerText, classes.color, classes.fonSize13, classes.bold)}>
                                        Register
                                    </Link>
                                </span>
                            </Typography>
                            <NormalSelect name="lang" signedIn={true} signedInId={idNamingConversion('Stay Signed In', 'login', 'Radio')} id={idNamingConversion('language', 'login', 'DropDown')} margin10t={classes.margin10t} />
                        </Paper>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    )
}

export default Login